import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {CertificateDto, CommentationDto, Page} from '../../generated-model/model';
import {environment} from '../../environments/environment';
import {IgnoreNullHttpParams} from '../shared/Ignore-null-http-params';

@Injectable({providedIn: 'root'})
export class CommentationRest {

  http = inject(HttpClient)

  save(commentDto: CommentationDto){
    return this.http.post(`${environment.serverUrl}/api/commentations/save`, commentDto)
  }

  search(params:IgnoreNullHttpParams){
    return this.http.get<Page<CommentationDto>>(`${environment.serverUrl}/api/commentations/search`, {params:params.toHttpParam()})
  }

  public export(params:IgnoreNullHttpParams){
    return this.http.get(`${environment.serverUrl}/api/commentations/export`,{params:params.toHttpParam(),responseType:'blob'})
  }
}
